<div class="bc-container">
  <div class="title"> {{title}} </div>
  <div class="subtitle"> {{subtitle}} </div>
  <div style="height: 1.5rem;"></div>

  <p-button label="Cancelar" [text]="true" (onClick)="closeModal()" ngClass="custom-button"></p-button>
  <p-button [label]="confirmLabel" (onClick)="ref.close(true)" ngClass="custom-button-submit"></p-button>
</div>